var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"pa-0 d-flex align-center justify-center flex-column"},[_c('h2',{staticClass:"mt-10 text-center"},[_vm._v(" "+_vm._s(_vm.noDataTable)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }